import { useEffect, useState } from 'react';

/** Valeur mise à jour seulement après `delay` ms sans changement (recherche à la frappe). */
const useDebouncedValue = (value, delay = 300) => {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const t = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(t);
  }, [value, delay]);
  return debounced;
};

export default useDebouncedValue;
